import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { CommonService } from "src/app/Global-Services/common.service";
import { DatePipe } from "@angular/common";
import { HttpErrorResponse } from "@angular/common/http";
import { GlobalVariable } from "src/app/Variable/global-variable";
import { NgModel } from "@angular/forms";
import { ExcelUploadService } from "src/app/Global-Services/excel-upload.service";

@Component({
  selector: 'app-view-finance-user-mapping',
  standalone: false,
  templateUrl: './view-finance-user-mapping.component.html',
  styleUrl: './view-finance-user-mapping.component.css'
})
export class ViewFinanceUserMappingComponent implements OnInit {

  EmployeeName: string[];
  filteredEmployeeSingle: any [] =[];
  reverse = false;
  sortkey: any;
  EmployeeList = {
    Employee: null,
    EmployeeGPN: null
  };
  ViewFinanceUserRecordList = {
    ID: 0,
    EmployeeName: '',
    EmployeeGPN:'',
    ServiceLine: '',
    CurrentUserGPN: '',
    IsExport: false,
    TopRecord: 0,
    TotalRecord: 0,
    RecordFrom: 0,
    RecordTo: 0,
    TotalPageCount: 0,
    currentPage: 1,
    IDList: "",
    IsActive: null as boolean | null,
  };
  ServiceLineList: String[];
  selectedOptions: string[] = [];
  ViewFinanceUserMappingRecordList: any[];
  isLoading: boolean = false;

 @ViewChild('txtEmployeeGPN') txtEmployeeGPN?: NgModel;
  constructor(
    public route: ActivatedRoute,
    public gService: CommonService,
    public datepipe: DatePipe,
    private gVariable: GlobalVariable,
    private router: Router,
    public ExcelUpload: ExcelUploadService
  ) {}

  ngOnInit() {
    this.filteredEmployeeSingle = [];
    this.GetServiceLine();
    this.GetSearchAndExportResult("Search");
    this.ViewFinanceUserRecordList.CurrentUserGPN = this.gVariable.User.UserGPN;
  }

  GetEmpSearch(event: any, isGPNFilter: boolean = false) {
    const query = event.query;
    if ((query.length) >= 3) {
      this.gService.GetEmployeeSearch(query, this.gVariable.User.UserGPN).subscribe((data: any) => {
        if (data!=null && data.length > 0) {
          this.filteredEmployeeSingle = data;
        } else {
          this.EmployeeName = [];
          this.filteredEmployeeSingle = [];
        }
      },
        (err: HttpErrorResponse) => {
          this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
          });
          this.gService.RedirectToErrorPage(2);
        });
    }
  }




  OnClearSendUser() {
    this.ViewFinanceUserRecordList.EmployeeName = null;
    this.ViewFinanceUserRecordList.EmployeeGPN = null;
  }

   SetSelectedEmpGPN(event: any) {
    this.ViewFinanceUserRecordList.EmployeeName = event.value.EmpName;
    this.ViewFinanceUserRecordList.EmployeeGPN = event.value.EmpGPN;
  }

  GetServiceLine() {
    this.isLoading = true;
    this.gService.GetServiceLine().subscribe((data: any) => {
      if (data != null) {
        if (data.length > 0) {
          this.ServiceLineList = data;
        }
      }
    },
      (err: HttpErrorResponse) => {
        this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
        });
        this.gService.RedirectToErrorPage(2);
      });
  }

  sort(keyname: any) {
    this.sortkey = keyname;   // set the sortKey to the param passed
    this.reverse = !this.reverse; // if true make it false and vice versa
  }

  setPage(PageNumber: any) {
    this.ViewFinanceUserRecordList.currentPage = PageNumber;
    this.GetSearchAndExportResult('Search');
  }
  PreviousPage() {
    this.ViewFinanceUserRecordList.currentPage = this.ViewFinanceUserRecordList.currentPage - 1;
    this.GetSearchAndExportResult('Search');
  }
  NextPage() {
    this.ViewFinanceUserRecordList.currentPage = this.ViewFinanceUserRecordList.currentPage + 1;
    this.GetSearchAndExportResult('Search');
  }
  firstPage() {
    this.ViewFinanceUserRecordList.currentPage = 1;
    this.GetSearchAndExportResult('Search');
  }
  lastPage() {
    this.ViewFinanceUserRecordList.currentPage = this.ViewFinanceUserRecordList.TotalPageCount;
    this.GetSearchAndExportResult('Search');
  }

  range(count: any) {
    const ratings = [];
    let TotalPage = count;
    const Start = this.ViewFinanceUserRecordList.currentPage - 1;
    if (count > 5) {
      TotalPage = this.ViewFinanceUserRecordList.currentPage + 4;
      if (TotalPage > this.ViewFinanceUserRecordList.TotalPageCount) {
        TotalPage = this.ViewFinanceUserRecordList.currentPage + (this.ViewFinanceUserRecordList.TotalPageCount - this.ViewFinanceUserRecordList.currentPage);
      }
    }
    for (let i = Start; i < TotalPage; i++) {
      ratings.push(i);
    }
    return ratings;
  }

  GetSearchAndExportResult(type: string)
  {
    this.ViewFinanceUserRecordList.IDList = "";
    this.isLoading = true;

     if (type == "Search")
      this.ViewFinanceUserRecordList.IsExport = false;
     else
     {
      for (var i = 0; i < this.ViewFinanceUserMappingRecordList.length; i++) {
      if (this.ViewFinanceUserMappingRecordList[i].checked) {
        if (this.ViewFinanceUserRecordList.IDList == '') {
          this.ViewFinanceUserRecordList.IDList = this.ViewFinanceUserMappingRecordList[i].ID;
        }
        else {
          this.ViewFinanceUserRecordList.IDList += ',' + this.ViewFinanceUserMappingRecordList[i].ID
        }
      }
    }
      this.ViewFinanceUserRecordList.IsExport = true;
  }

    this.gService.PostService(this.ViewFinanceUserRecordList, 'AccessMatrix/GetAndExportFinanceUserMapping').subscribe(data => {
      if(type == "Search")
      {
      if (data != null) {
        if (data.length > 0) {
          this.ViewFinanceUserRecordList.TopRecord = data[0]['TopRec'];
          this.ViewFinanceUserRecordList.TotalRecord = data[0]['TotRec'];
          this.ViewFinanceUserRecordList.RecordFrom = data[0]['RecordFrom'];
          this.ViewFinanceUserRecordList.RecordTo = parseFloat(data[0]['RecordFrom']) + (data.length - 1);
          this.ViewFinanceUserRecordList.TotalPageCount = data[0]['TotalPageCount'];
          this.ViewFinanceUserMappingRecordList = data;
        } else {
          this.ViewFinanceUserMappingRecordList = data;
          this.ViewFinanceUserRecordList.TopRecord = 0;
          this.ViewFinanceUserRecordList.TotalRecord = 0;
          this.ViewFinanceUserRecordList.RecordFrom = 0;
          this.ViewFinanceUserRecordList.RecordTo = 0;
          this.ViewFinanceUserRecordList.TotalPageCount = 0;
          this.ViewFinanceUserRecordList.currentPage = 1;
        }
      }
    }
    else
    {
        this.ExcelUpload.exportAsExcelFile(data, 'FinanceUserMapping_List');
    }
    this.isLoading = false;
    },
      (err: HttpErrorResponse) => {
        this.isLoading = false;
        this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
        });
        this.gService.RedirectToErrorPage(2);
      });
  }

  ResetResult()
  {
    this.ViewFinanceUserRecordList.ID = 0;
    this.ViewFinanceUserRecordList.EmployeeName = '';
    this.ViewFinanceUserRecordList.EmployeeGPN ='';
    this.ViewFinanceUserRecordList.ServiceLine = '';
    this.ViewFinanceUserRecordList.IsExport = false;
    this.ViewFinanceUserRecordList.TopRecord = 0;
    this.ViewFinanceUserRecordList.TotalRecord = 0;
    this.ViewFinanceUserRecordList.RecordFrom = 0;
    this.ViewFinanceUserRecordList.RecordTo = 0;
    this.ViewFinanceUserRecordList.TotalPageCount = 0;
    this.ViewFinanceUserRecordList.currentPage = 1;
    this.ViewFinanceUserRecordList.IsActive = null;
    this.EmployeeList.Employee = '';
    this.EmployeeList.EmployeeGPN = '';
    this.GetSearchAndExportResult('Search');
  }


  onExit()
  {
    let confirm = false;
    const message = 'Are You Sure Want to Exit.';
    confirm = window.confirm(message);

    if (confirm) {
      this.router.navigate(['/INFTE/home']);
    }
  }

  OnClickFinanceUserMappingRecord(ID: any) {
    this.router.navigate(['/View/CreateFinanceUserMappingComponent/' + ID]);
  }

  MarkRecordInActiveFinanceMatrix(type: any)
  {
    this.isLoading = true;
    var IDList = '';
    for (var i = 0; i < this.ViewFinanceUserMappingRecordList.length; i++) {
      if (this.ViewFinanceUserMappingRecordList[i].checked) {
        if (IDList == '') {
          IDList = this.ViewFinanceUserMappingRecordList[i].ID;
        }
        else {
          IDList += ',' + this.ViewFinanceUserMappingRecordList[i].ID
        }
      }
    }

    const param = {
    'IDList': IDList,
    'Type': type
    }

    this.gService.PostDataWithParam('AccessMatrix/MarkRecordInActiveFinanceMatrix', param).subscribe(data => {
      if (data != null) {
        if (data == "Success") {
          if(type == "InActive")
          alert("Record has been marked as inActive!");
        else
          alert("Record has been marked as Active!");
          this.GetSearchAndExportResult('Search');
        }
      }
    this.isLoading = false;
    },
      (err: HttpErrorResponse) => {
        this.isLoading = false;
        this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
        });
        this.gService.RedirectToErrorPage(2);
      });
    }
}
